import { useEffect, useState } from "react";

export const FLEET_COUNT_FALLBACK = 266;

export default function useFleetAircraftCount() {
  const [fleetCount, setFleetCount] = useState(FLEET_COUNT_FALLBACK);

  useEffect(() => {
    const controller = new AbortController();

    fetch("/api-public/fleet-count/", {
      cache: "no-cache",
      headers: { Accept: "application/json" },
      signal: controller.signal,
    })
      .then((response) => {
        if (!response.ok) throw new Error(`Fleet count request failed: ${response.status}`);
        return response.json();
      })
      .then((payload) => {
        const count = Number(payload?.aircraftCount);
        if (Number.isSafeInteger(count) && count > 0) setFleetCount(count);
      })
      .catch((error) => {
        if (error.name !== "AbortError") {
          // Keep the latest known count visible while the source is unavailable.
        }
      });

    return () => controller.abort();
  }, []);

  return fleetCount;
}
